import React, { useEffect } from 'react';
import { Modal, Table } from 'reactstrap';
import LoadingContainer from '../LoadingContainer';
import { TInventory } from '~domain/inventory/Inventory';
import { listInventoriesByProduct } from '~graphql/queries';
import { getProductTypeString } from '~utils/product';
import { useGraphql } from '~view/hooks/graphql';

const InventoryModal: React.FC<{
  productId: string;
  isOpen: boolean;
  toggle: () => void;
}> = ({ productId, isOpen, toggle }) => {
  const [inventories, fetch, loading] = useGraphql<TInventory[]>(
    listInventoriesByProduct,
    (data) =>
      (data.listInventoriesByProduct.items as TInventory[])?.filter(
        (inventory) =>
          !inventory.product?.suspended && !inventory.productType?.suspended
      )
  );

  useEffect(() => {
    fetch({ product_id: productId });
  }, [productId]);

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      {loading && <LoadingContainer isLoading />}
      {!loading && (
        <Table borderless className="border">
          <thead>
            <tr className="border-bottom">
              <th
                style={{
                  width: '300px',
                }}
              >
                サイズ、カラー、種類
              </th>
              <th>残り個数</th>
            </tr>
          </thead>
          <tbody>
            {inventories?.map(
              (inventory) =>
                inventory.productType &&
                (inventory.productType.published ?? true) &&
                inventory.inventory !== undefined && (
                  <tr className="border-bottom">
                    <td
                      className="align-middle"
                      style={{
                        width: '300px',
                      }}
                    >
                      {getProductTypeString(inventory.productType)}
                    </td>
                    <td className="align-middle">
                      {inventory.inventory === 0
                        ? '売り切れ'
                        : inventory.inventory}
                    </td>
                  </tr>
                )
            )}
          </tbody>
        </Table>
      )}
    </Modal>
  );
};

export default InventoryModal;
